const jQ = jQuery.noConflict();
const paginationWrapper = jQ('.pagination-wrapper');
const mobilechecker = window.matchMedia('screen and (max-width: 768px)');

function setPagination() {
    if (paginationWrapper && (jQ('.blog').length > 0)) {
        const pageNr = jQ('.pagination-btn');
        const first = jQ('.pagination-btn').first();
        const last = jQ('.pagination-btn').last();
        const prev = jQ('.arr-prev');
        const next = jQ('.arr-next');
        const current = jQ('.pagination-btn.active');
        let i;
        jQ('.pagination-btn').removeClass('visible');
        last.addClass('visible');
        jQ('.dots').remove();

        if (mobilechecker.matches) {
            for (i = current.index(); i <= current.index() + 2; i++) {
                const eq = i;

                pageNr.eq(eq).addClass('visible remove-item');
            }
        } else {
            for (i = current.index(); i <= current.index() + 4; i++) {
                const eq = i;

                pageNr.eq(eq).addClass('visible remove-item');
            }
        }

        if (pageNr.length >= 7) {
            // add dots before last page item
            jQ('.pagination-btn.visible').eq(-2).after('<span class="dots">...</span>');
            pageNr.addClass('hide-nr');
            if (!(first.hasClass('visible'))) {
                jQ('.pagination-btn.visible').eq(0).before('<span class="dots">...</span>');
            }

            // remove dots if before last pagination item
            if (pageNr.eq(-2).hasClass('visible')) {
                pageNr.eq(-2).next('.dots').remove();
            }

            // remove dots if before first pagination item
            if (pageNr.eq(1).hasClass('visible')) {
                console.log(pageNr.eq(1));
                pageNr.eq(1).prev('.dots').remove();
            }
        }

        // deactivate prev arrow if on first page
        if (first.hasClass('active')) {
            prev.addClass('hidden');
        } else if (prev.hasClass('hidden')) {
            prev.removeClass('hidden');
        }
        // deactivate next arrow if on last page
        if (last.hasClass('active')) {
            next.addClass('hidden');
        } else if (next.hasClass('hidden')) {
            next.removeClass('hidden');
        }
    }
}

function searchPagination() {
    if (jQ('.search-results').length > 0) {
        const pageNr = jQ('.page-nr');
        const first = pageNr.first();
        const last = pageNr.last();
        const active = jQ('.page-nr.active-item');
        let i;
        last.addClass('last-page');
        first.addClass('first-page');
        if (mobilechecker.matches) {
            for (i = active.index(); i <= active.index() + 2; i++) {
                const eq = i - 1;

                pageNr.eq(eq).addClass('visible');
            }
        } else {
            for (i = active.index(); i <= active.index() + 5; i++) {
                const eq = i - 1;

                pageNr.eq(eq).addClass('visible');
            }
        }
        if (pageNr.length >= 7) {
            // add dots before last page item
            pageNr.eq(-2).after('<span class="dots">...</span>');
            pageNr.addClass('hide-nr');
            if (!(first.hasClass('active-item'))) {
                active.before('<span class="dots">...</span>');
            }

            // remove dots if before last pagination item
            if (pageNr.eq(-2).hasClass('visible')) {
                pageNr.eq(-2).next('.dots').remove();
            }

            // remove dots if before first pagination item
            if (pageNr.eq(1).hasClass('visible')) {
                pageNr.eq(1).prev('.dots').remove();
            }
        }
    }
}

export { setPagination, searchPagination };
